"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mainKeywordNameValueMap = exports.mainKeywordNameValue = exports.MainKeywordEnum = void 0;
var MainKeywordEnum;
(function (MainKeywordEnum) {
    MainKeywordEnum["BANKRUPTCY_LAW"] = "BANKRUPTCY_LAW";
    MainKeywordEnum["BUSINESS_CONTRACTS"] = "BUSINESS_CONTRACTS";
    MainKeywordEnum["COMMERCIAL_LEASES"] = "COMMERCIAL_LEASES";
    MainKeywordEnum["COMPETITION"] = "COMPETITION";
    MainKeywordEnum["COMPLIANCE"] = "COMPLIANCE";
    MainKeywordEnum["CONSUMPTION"] = "CONSUMPTION";
    MainKeywordEnum["CORPORATE_CRIMINAL_LIABILITY"] = "CORPORATE_CRIMINAL_LIABILITY";
    MainKeywordEnum["CORPORATE_LAW"] = "CORPORATE_LAW";
    MainKeywordEnum["DISTRIBUTION"] = "DISTRIBUTION";
    MainKeywordEnum["EU_BUSINESS_LAW"] = "EU_BUSINESS_LAW";
    MainKeywordEnum["INDUSTRIAL_PROPERTY_LAW"] = "INDUSTRIAL_PROPERTY_LAW";
    MainKeywordEnum["PROCEDURAL_LAW"] = "PROCEDURAL_LAW";
})(MainKeywordEnum || (exports.MainKeywordEnum = MainKeywordEnum = {}));
var mainKeywordNameValue = [
    {
        label: 'Droit de la concurrence',
        value: MainKeywordEnum.COMPETITION,
    },
    {
        label: 'Droit de la consommation',
        value: MainKeywordEnum.CONSUMPTION,
    },
    {
        label: 'Droit de la distribution',
        value: MainKeywordEnum.DISTRIBUTION,
    },
    {
        label: 'Droit européen des affaires',
        value: MainKeywordEnum.EU_BUSINESS_LAW,
    },
    {
        label: 'Procédures collectives',
        value: MainKeywordEnum.BANKRUPTCY_LAW,
    },
    {
        label: 'Droit des sociétés',
        value: MainKeywordEnum.CORPORATE_LAW,
    },
    {
        label: 'Baux commerciaux',
        value: MainKeywordEnum.COMMERCIAL_LEASES,
    },
    {
        label: "Contrats d'affaires",
        value: MainKeywordEnum.BUSINESS_CONTRACTS,
    },
    {
        label: 'Propriété industrielle',
        value: MainKeywordEnum.INDUSTRIAL_PROPERTY_LAW,
    },
    {
        label: 'Droit pénal des affaires',
        value: MainKeywordEnum.CORPORATE_CRIMINAL_LIABILITY,
    },
    {
        label: 'Droit de la compliance',
        value: MainKeywordEnum.COMPLIANCE,
    },
    {
        label: 'Droit processuel',
        value: MainKeywordEnum.PROCEDURAL_LAW,
    },
];
exports.mainKeywordNameValue = mainKeywordNameValue;
var mainKeywordNameValueMap = new Map();
exports.mainKeywordNameValueMap = mainKeywordNameValueMap;
mainKeywordNameValue.forEach(function (_a) {
    var label = _a.label, value = _a.value;
    return mainKeywordNameValueMap.set(value, label);
});
//# sourceMappingURL=glossaryTerms.js.map